import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap"
import { CircularProgress } from "@mui/material";
import { getProducts } from "../api/Product.api";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { Product } from "../components/Product"

const HIDDEN_STOCK_CODES = ["H-DWAY-DROP&GO", "H-FULL-DROP&GO"];

export default function Products() {
  const [isLoading, setIsLoading] = useState(true);
  const { products, setProducts } = useShoppingCart();


  useEffect(() => {
    getProducts()
      .then((response) => {
        setProducts(response.data);
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <Container>
      <h2 className="mb-3">Choose your iStore Products</h2>
      {isLoading ? (
        <div className="d-flex justify-content-center"><CircularProgress /></div>
      ) : products?.length ? (
        <Row xs={1} md={2} lg={3} className="g-3">
          {products
            .filter(item => !HIDDEN_STOCK_CODES.includes(item.STOCKCODE))
            .map((item) => (
              <Col key={item.ID}>
                <Product {...item} />
              </Col>
            ))}
        </Row>
      ) : (
        <div className="mt-5 d-flex justify-content-center fst-italic text-secondary ">
          No Products Available
        </div>
      )}
    </Container>
  )
}
